import { createRoute } from "@tanstack/react-router";
import { CaseAgentChat } from "@/components/case-agent-chat";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from "@/components/ui/empty";
import { useVersionLive } from "@/hooks/use-version-live";
import { versionLayoutRoute } from "./version-layout-route";

export const versionAgentRoute = createRoute({
  getParentRoute: () => versionLayoutRoute,
  path: "/agent",
  component: VersionAgentPage,
});

function VersionAgentPage() {
  const { versionId, liveStatus, agentItems, agentBusy, sendAgentPrompt, cancelAgent } =
    useVersionLive();

  if (!versionId) {
    return (
      <Empty className="border border-border py-8">
        <EmptyHeader>
          <EmptyTitle>无版本</EmptyTitle>
          <EmptyDescription>
            打开一个版本以与案件 Agent 对话。
          </EmptyDescription>
        </EmptyHeader>
      </Empty>
    );
  }

  return (
    <CaseAgentChat
      versionId={versionId}
      liveStatus={liveStatus}
      items={agentItems}
      busy={agentBusy}
      onSend={(text) => sendAgentPrompt(text)}
      onCancel={() => cancelAgent()}
    />
  );
}
